import { BelongItemList } from './BelongItemList'
import { BelongItemStatus } from './BelongItemStatus'

export type CategorizedItems = {
  READY_TO_USE: BelongItemList
  PENDING: BelongItemList
  LOST: BelongItemList
  DAMAGED: BelongItemList
}
//TODO: Isso pode ser implementado na propria BelongItemList
export function categorizeItemsByStatus(
  items: BelongItemList
): CategorizedItems {
  return items.reduce(
    (acc, item) => {
      const status = item.status as BelongItemStatus
      acc[status].push(item)
      return acc
    },
    {
      READY_TO_USE: [],
      PENDING: [],
      LOST: [],
      DAMAGED: []
    }
  )
}
